"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdAccountSourceToJSON = exports.AdAccountSourceFromJSONTyped = exports.AdAccountSourceFromJSON = exports.instanceOfAdAccountSource = void 0;
var runtime_1 = require("../runtime");
var AdAccountSourceType_1 = require("./AdAccountSourceType");
/**
 * Check if a given object implements the AdAccountSource interface.
 */
function instanceOfAdAccountSource(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfAdAccountSource = instanceOfAdAccountSource;
function AdAccountSourceFromJSON(json) {
    return AdAccountSourceFromJSONTyped(json, false);
}
exports.AdAccountSourceFromJSON = AdAccountSourceFromJSON;
function AdAccountSourceFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'sourceType': !(0, runtime_1.exists)(json, 'source_type') ? undefined : (0, AdAccountSourceType_1.AdAccountSourceTypeFromJSON)(json['source_type']),
        'sourceId': !(0, runtime_1.exists)(json, 'source_id') ? undefined : json['source_id'],
    };
}
exports.AdAccountSourceFromJSONTyped = AdAccountSourceFromJSONTyped;
function AdAccountSourceToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'source_type': (0, AdAccountSourceType_1.AdAccountSourceTypeToJSON)(value.sourceType),
        'source_id': value.sourceId,
    };
}
exports.AdAccountSourceToJSON = AdAccountSourceToJSON;
